export default __webpack_public_path__ + "static/media/99a59c1fa400d465.9c760a7ba21dc114ccfd5b46ffc8deab.svg";